import { TableCell } from '@mui/material';
import { MobileRowStyled } from './mobileRow.styled';
import { getDisplayNameStatusBooking, getRoom } from '../../../../utils/utils';
import { useSelector } from 'react-redux';
import moment from 'moment';
import i18n from '../../../../translations/strings';

interface Props {
    row: any,
    data: any,
    fields: any[]
}

const MobileRow = (props: Props) => {
    const { rooms } =
    useSelector((state: any) => {
      return state.reservationsList;
    });

    const {row, data, fields} = props

    const findIntervalsById = (list: any[], id: string) => {
        const result = list.find(item => item.id === id);
        return result ? result.interval : null;
    }

    const intervalsInfo = findIntervalsById(data, row.id)

    const formattedDate = (date: string, full: boolean = true) => full
        ? new Date(date).toLocaleString(i18n.t( 'bookingMobile.dateTime' ), { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        : moment.utc(date).format('HH:mm')

    const formattedTitle = (str: string) => new Date(str).toLocaleString(i18n.t( 'bookingMobile.dateTime' ), { year: 'numeric', month: 'long', day: 'numeric' })

    return (
        <MobileRowStyled.Container>
            <MobileRowStyled.MobileRowInfo>
                <MobileRowStyled.RowLabel>{i18n.t( 'bookingMobile.bookedWhen' )}</MobileRowStyled.RowLabel>
                <p>{formattedDate(row.created_at)}</p>
                <MobileRowStyled.RowLabel>{i18n.t( 'bookingMobile.bookingId' )}</MobileRowStyled.RowLabel>
                <p>{row.id}</p>
                <MobileRowStyled.RowLabel>{i18n.t( 'bookingMobile.bookingStatus' )}</MobileRowStyled.RowLabel>
                <p>{getDisplayNameStatusBooking(row.status)}</p>
                <MobileRowStyled.RowLabel>{i18n.t( 'bookingMobile.eventsList' )} ({intervalsInfo.length})</MobileRowStyled.RowLabel>
                {intervalsInfo.map((interval: any) => (
                    <MobileRowStyled.Interval key={interval.id}>
                        <MobileRowStyled.IntervalName>{formattedTitle(interval.start)}</MobileRowStyled.IntervalName>
                        <p>{formattedDate(interval.start, false)} - {formattedDate(interval.end, false)}</p>
                        <p>{interval.attendees} {i18n.t( 'bookingMobile.attendees' )}</p>
                        <p>{getRoom(rooms, interval.product).name}</p>
                    </MobileRowStyled.Interval>
                ))}
            </MobileRowStyled.MobileRowInfo>
            <MobileRowStyled.MobileRowActions>
                {fields.map((item: any, index: number) => (
                    item.name === 'edit' &&
                        <TableCell
                            key={index}
                            align="left"
                            >
                            {item.component ? item.component(row) : row[item.name]}
                        </TableCell>
                ))}
            </MobileRowStyled.MobileRowActions>
        </MobileRowStyled.Container>
    )
}

export default MobileRow
